import React from "react";
import { GoogleOAuthProvider } from "@react-oauth/google";

const GoogleAuth = ({ children }) => (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_LOGIN_CLIENT_ID}>
        {children}
    </GoogleOAuthProvider>
);

export default GoogleAuth;